/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { globalBreak } from '@/styles/break';
import { SxProps } from '@mui/material';

export const storeLocatorSideListSideListSX: SxProps = {
	overflowY: 'scroll',
//	maxHeight: globalBreak({mobile:'70vh', desktop:602}),
//	minHeight: 602
'& .storeLocatorSideList__cityName':{
	color:'#000'
}
};